/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_DepartmentInputs */

const en_page_title_department = /** @type {(inputs: Page_Title_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const nl_page_title_department = /** @type {(inputs: Page_Title_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afdeling`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {Page_Title_DepartmentInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_department = /** @type {((inputs?: Page_Title_DepartmentInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_DepartmentInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_department(inputs)
	return en_page_title_department(inputs)
});